import axios from "axios";
import { toast } from "react-toastify";
export const GetAllHierarchy = (data) => {
  return {
    type: "get_allhierarchy",
    payload: data,
    loader: false,
  };
};
export function getallHierarchy() {
  return (dispatch) => {
    axios({
      url: `${process.env.REACT_APP_API_URL}CRMTeams/Hierarchy/Populate`,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllHierarchy(result.data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
